import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@store/Components/Icons/Search";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

Object.assign(searchWithinStyles, {
    titleText: {
        forwardAs: "h4",
        size: TYPOGRAPHY.size.smallest,
        weight: TYPOGRAPHY.weight.bold,
        css: css`
            padding-bottom: 0.5em;
        `,
    },
    searchTextField: {
        sizeVariant: "small",
        iconProps: {
            src: Search,
        },
    },
});
